/* eslint-disable indent */
/* eslint-disable no-undef */
export default {
	name: "customer-discount-groups-management",
	data() {
		return {
			customerDiscountGroups: [],
			customerDiscountGroupsHeadings: [
				{
					text: "Name",
					field: "name"
				},
				{
					text: "Discount Amount",
					field: "discountAmountAsString"
				},
				{
					text: "Is Active",
					field: "isActive"
				}
			],
			pagingDetails:{
				pageNumber: 1,
				pageSize: 10,
				totalPages: 1
			},
			actionKeys:{
				edit: "edit",
				markAsActiveInactive: "markAsActiveInactive",
				linkProducts: "linkProducts",
				linkCustomers: "linkCustomers"
			},
			customerDiscountGroupAddEditFormModal:{
				showModal: false,
				isSaving: false,
				modalId: "addEditCustomerDiscountGroupModal",
				heading: "Add Customer Discount Group",
				customerDiscountGroup:{
					customerDiscountGroupId: null,
					isActive: true,
					name: {
						value: null,
						hasError: false,
						errorMessage: null
					},
					discountAmount: {
						value: null,
						hasError: false,
						errorMessage: null
					}
				}
			},
			customerDiscountGroupMarkAsActiveInactiveModal:{
				showModal: false,
				isSaving: false,
				modalId: "markCustomerDiscountGroupAsActiveInactiveModal",
				heading: "Mark Customer Discount Group As Active/Inactive",
				isActive: null,
				customerDiscountGroupId: null
			},
			linkProductsToDiscountGroupModal: {
				showModal: false,
				isSaving: false,
				modalId: "linkProductsToDiscountGroupModal",
				heading: "Link Products To Discount Group",
				customerDiscountGroupId: null
			},
			filterStateChanged: false,
			filter:{
				customerSearchQuery: null,
				activeOrInactiveItems: 1
			},
			activeIsActiveKey:{
				active: 1,
				inactive: 0
			},
			pageNumber: 1,
			pageSize: 100,
			loading: false,
			selectedHeartbeatStatusCodeId: null
		};
	},
	methods: {
		getCustomerDiscountGroups() {
			this.loading = true;
			let request ={
				searchQuery: this.filter.customerSearchQuery,
				pageNumber: this.pagingDetails.pageNumber,
				pageSize: this.pagingDetails.pageSize,
				isActive: castingUtility.toBoolean(this.filter.activeOrInactiveItems),
			};
			orderService.getDiscountGroups(request).then(
				successResponse => {
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						this.customerDiscountGroups = successResponse.data.result;
						this.pagingDetails.pageNumber = successResponse.data.pagingInfo.thisPage;
						this.pagingDetails.totalPages = successResponse.data.pagingInfo.totalPages;
						for(let i = 0; i < this.customerDiscountGroups.length; i++) {
							this.customerDiscountGroups[i].actions = [
								{
									name: "Edit",
									key: this.actionKeys.edit
								},
								{
									name: this.customerDiscountGroups[i].isActive ? "Mark As Inactive" : "Mark As Active",
									key: this.actionKeys.markAsActiveInactive
								},
								// {
								// 	name: "Link Products",
								// 	key: this.actionKeys.linkProducts
								// },
								// {
								// 	name: "Link Customers",
								// 	key: this.actionKeys.linkCustomers
								// }
							];
							this.customerDiscountGroups[i].discountAmountAsString = currencyHelper.numberToCurrency(this.customerDiscountGroups[i].discountAmount);
						}
						this.customerDiscountGroups = dataTableHelper.castFieldValues(this.customerDiscountGroups);
						this.filterStateChanged = false;
					}
					this.loading = false;
				},
				errorResponse => {
					this.loading = false;
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		onFilterSearchClicked(){
			console.log("Search filter clicked");
			//TODO: filter customer results
			this.getCustomerDiscountGroups();
		},
		onActiveInactiveFilterSelected(activeOrInactiveKey){
			this.filter.activeOrInactiveItems = activeOrInactiveKey;
			this.filterStateChanged = true;
			console.log("filter", this.filter);
		},
		onAddCustomerDiscountGroupClick(){
			// this.customerDiscountGroupAddEditFormModal.heading = "Add Customer Discount Group";
			// this.clearCustomerDiscountGroupModel();
			// this.customerDiscountGroupAddEditFormModal.showModal = true;
			this.$router.push("/pricing/collection/customerDiscountGroups/addOrEditDiscountGroup");
		},
		onCustomerDiscountGroupActionClicked(actionAndData){
			console.log("actionAndData", actionAndData);
			switch(actionAndData.action){
				case this.actionKeys.edit:
					// this.customerDiscountGroupAddEditFormModal.showModal = true;
					// this.customerDiscountGroupAddEditFormModal.heading = "Edit Customer Discount Group";
					// this.customerDiscountGroupAddEditFormModal.customerDiscountGroup.name.value = actionAndData.data.name;
					// this.customerDiscountGroupAddEditFormModal.customerDiscountGroup.discountAmount.value = actionAndData.data.discountAmount;
					// this.customerDiscountGroupAddEditFormModal.customerDiscountGroup.customerDiscountGroupId = actionAndData.data.discountGroupId;
					// this.customerDiscountGroupAddEditFormModal.customerDiscountGroup.isActive = castingUtility.toBoolean(actionAndData.data.isActive);
					this.$router.push("/pricing/collection/customerDiscountGroups/addOrEditDiscountGroup/" + actionAndData.data.discountGroupId);
					break;
				case this.actionKeys.markAsActiveInactive:
					this.customerDiscountGroupMarkAsActiveInactiveModal.showModal = true;
					this.customerDiscountGroupMarkAsActiveInactiveModal.customerDiscountGroupId = actionAndData.data.discountGroupId;
					this.customerDiscountGroupMarkAsActiveInactiveModal.isActive = castingUtility.toBoolean(actionAndData.data.isActive);
					this.customerDiscountGroupMarkAsActiveInactiveModal.heading = "Mark Customer Discount Group As " + (this.customerDiscountGroupMarkAsActiveInactiveModal.isActive ? "Inactive" : "Active") + " - " + actionAndData.data.name;
					break;
				case this.actionKeys.linkProducts:
					this.linkProductsToDiscountGroupModal.showModal = true;
					this.linkProductsToDiscountGroupModal.heading = "Link Products To Discount Group - " + actionAndData.data.name;
					this.linkProductsToDiscountGroupModal.customerDiscountGroupId = actionAndData.data.discountGroupId;
					break;
				case this.actionKeys.linkCustomers:
					this.$router.push("/pricing/collection/customerDiscountGroups/linkProductsToCustomerDiscountGroup/" + actionAndData.data.discountGroupId);
			}
		},
		onPagingUpdated(pagingInfo){
			this.pagingDetails.pageNumber = pagingInfo.pageNumber;
			this.getCustomerDiscountGroups();
		},
		onMarkCustomerDiscountGroupActiveInactiveSelected(isActive){
			this.customerDiscountGroupMarkAsActiveInactiveModal.isActive = isActive;
			console.log("customerDiscountGroupMarkAsActiveInactiveModal.isActive", this.customerDiscountGroupMarkAsActiveInactiveModal.isActive);
		},
		onMarkAsActiveInactiveSaveClick(markAsActive){
			this.customerDiscountGroupMarkAsActiveInactiveModal.isSaving = true;
			let request ={
				discountGroupId: this.customerDiscountGroupMarkAsActiveInactiveModal.customerDiscountGroupId,
				isActive: markAsActive
			};
			orderService.markDiscountGroupAsActiveOrInactive(request).then(
				successResponse => {
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						this.getCustomerDiscountGroups();
						this.customerDiscountGroupMarkAsActiveInactiveModal.showModal = false;
					}
					this.customerDiscountGroupMarkAsActiveInactiveModal.isSaving = false;
				},
				errorResponse => {
					this.customerDiscountGroupMarkAsActiveInactiveModal.isSaving = false;
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		onAddOrEditCustomerDiscountGroupModalCloseClick(){
			this.customerDiscountGroupAddEditFormModal.showModal = false;
			this.clearCustomerDiscountGroupModel();
		},
		onAddOrEditCustomerDiscountGroupSaveClick(){
			this.customerDiscountGroupAddEditFormModal.isSaving = true;
			let request ={
				discountGroupId: this.customerDiscountGroupAddEditFormModal.customerDiscountGroup.customerDiscountGroupId === null ? 0 : this.customerDiscountGroupAddEditFormModal.customerDiscountGroup.customerDiscountGroupId,
				name: this.customerDiscountGroupAddEditFormModal.customerDiscountGroup.name.value,
				discountAmount: this.customerDiscountGroupAddEditFormModal.customerDiscountGroup.discountAmount.value === null ? 0 : this.customerDiscountGroupAddEditFormModal.customerDiscountGroup.discountAmount.value,
				isActive: this.customerDiscountGroupAddEditFormModal.customerDiscountGroup.isActive
			};
			orderService.addOrUpdateDiscountGroup(request).then(
				successResponse => {
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						if(successResponse.data.discountGroupValidationResponse.valuesAreValid){
							this.getCustomerDiscountGroups();
							this.clearCustomerDiscountGroupModel();
							this.customerDiscountGroupAddEditFormModal.showModal = false;
						}
						else{
							this.customerDiscountGroupAddEditFormModal.customerDiscountGroup.name.hasError = successResponse.data.discountGroupValidationResponse.nameValidationResponse.hasError;
							this.customerDiscountGroupAddEditFormModal.customerDiscountGroup.name.errorMessage = successResponse.data.discountGroupValidationResponse.nameValidationResponse.message;
							this.customerDiscountGroupAddEditFormModal.customerDiscountGroup.discountAmount.hasError = successResponse.data.discountGroupValidationResponse.discountAmountValidationResponse.hasError;
							this.customerDiscountGroupAddEditFormModal.customerDiscountGroup.discountAmount.errorMessage = successResponse.data.discountGroupValidationResponse.discountAmountValidationResponse.message;
						}
					}
					this.customerDiscountGroupAddEditFormModal.isSaving = false;
				},
				errorResponse => {
					this.customerDiscountGroupAddEditFormModal.isSaving = false;
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		onLinkProductsToCustomerGroupModalOkClick(){
			this.linkProductsToDiscountGroupModal.showModal = false;
			this.linkProductsToDiscountGroupModal.customerDiscountGroupId = 0;
		},
		clearCustomerDiscountGroupModel(){
			this.customerDiscountGroupAddEditFormModal.customerDiscountGroup = {
				customerDiscountGroupId: null,
				isActive: true,
				name: {
					value: null,
					hasError: false,
					errorMessage: null
				},
				discountAmount: {
					value: null,
					hasError: false,
					errorMessage: null
				}
			}
		},
		setBreadcrumbs() {
			storeState.setPageTitleAction("Discount Groups");
			var breadcrumbs = [];
			var breadcrumbLogistics = {
				url: null,
				displayText: "Pricing"
			};
			var driverManagementBreadcrumb = {
				url: this.$route.path,
				displayText: "Discount Groups"
			};
			breadcrumbs.push(breadcrumbLogistics);
			breadcrumbs.push(driverManagementBreadcrumb);
			breadcrumbsStoreState.setBreadcrumbs(breadcrumbs);
		}
	},
	mounted: function () {
		this.setBreadcrumbs();
		this.getCustomerDiscountGroups();
	}
};